import { ChangeDetectorRef, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { filter, takeUntil } from 'rxjs/operators';
import { SimpleTableComponent } from '../../generals/Components';
import { PageItem } from '../../interfaces/interfaces';
import { ApiService } from '../../services/api.service';
import { ConfirmComponent } from '../confirm/confirm.component';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html'
})
export class PagesComponent extends SimpleTableComponent<PageItem> {

  constructor(
    private apiServiceRef: ApiService,
    private dialogService: DialogService,
    private changeDetectionRef: ChangeDetectorRef
  ) {
    super(changeDetectionRef, apiServiceRef);
    this.endPoint = 'pages';
  }

  showPageDeleteModal(pageId: number): void {
    this.dialogService.open(ConfirmComponent, {
      data: {
        title: 'Oldal törlése',
        text: 'Biztosan törölni szeretnéd ezt az oldalt?',
        acceptText: 'Törlés',
        declineText: 'Mégse'
      }
    }).onClose.pipe(filter(r => r === true)).subscribe(() => {
      this.apiServiceRef.deletePage(pageId).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.refreshTable();
      });
    });
  }
}
